import templateUrl from 'webmodals/tray.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'

export default {
    bindings: {
        tray: '<instance',
        title: '@trayTitle',
        subTitle: '@',
        hideHeader: '@',
        hideCloseButton: '@',
        hideFooter: '@',
        onDismiss: '&',
        onClose: '&',
        preventAutoHeight: '@',
    },
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    },
    transclude: {
        header: '?trayHeader',
        rawHeader: '?trayRawHeader',
        //title: '?trayTitle',
        body: '?trayBody',
        raw: '?trayRaw',
        rawFooter: '?trayRawFooter',
        footer: '?trayFooter'
    },
    controller($transclude) {
        let $ctrl = this;
        basicController($ctrl);
        $ctrl.isSlotFilled = (slot) => $transclude.isSlotFilled(slot);
        $ctrl.maxHeight = () => $ctrl.$pageConfig.height-100;
    }
};